export const PageRoutesToModule = {
    "": { module: "basic", title: "Dashboard" },
    Documentation: { module: "basic" },
    facilities: { module: "basic", title: "Facilities" },
    cells: { module: "basic", title: "Cells" },
    equipment: { module: "basic", title: "Equipment" },
    "cell-layout": { module: "basic", title: "Cell Layout" },
    products: { module: "basic", title: "Products" },
    monitor_live_data: { module: "basic", title: "Signal Data" },
    scada1: { module: "basic", title: "Signal Layout" },
    scada2: { module: "basic", title: "Signal Data" },
    monitor_rules: { module: "controls", title: "Rules Control" },
    monitor_machine_learning: { module: "controls", title: "ML Control" },
    historical_runs: { module: "controls", title: "Historical Runs" },
    live_services: { module: "controls", title: "Live Services" },
    advanced_controllers: { module: "basic", title: "Advanced Controllers" },
    material_tracking: { module: "basic", title: "Material Tracking" },
    virtual_sensor: { module: "virtualsensor", title: "Virtual Sensor" },
    graphs_charts: { module: "reporting", title: "Reporting - Run Reports" },
    impact_kpi: { module: "reporting", title: "Reporting - Impact KPI" },
    rules_configuration: { module: "controls", title: " Rule Configuration" },
    process_insight: { module: "controls", title: " Process Insight" },
    alerts_configuration: { module: "controls", title: "Alerts Configuration" },
    ml_configuration: { module: "controls", title: "ML Configuration" },
    dpk: { module: "controls", title: "DPK" },
    lpp: { module: "controls", title: "Liveline Physics Packages" },
    lcp: { module: "controls", title: "Liveline Controls Packages" },
    backtest: { module: "controls", title: "Back Test" },
    ghost_scheduler: { module: "controls", title: "Ghost Scheduler" },
    lcp_performance: { module: "controls", title: "LCP Performance" },
    monitor: { module: "alarms", title: "Predictive Alarms - Monitor" },
    monitor_stack: { module: "basic", title: "Monitor Stack" },
    lcp_performance_details: { module: "controls", title: "LCP Performance" },
    contact_us: { module: "basic", title: "Contact Us" },
    ml_controller_dashboard: {
        module: "basic",
        title: " / ML Controller / Dashboard",
    },
    ml_controller_charts: {
        module: "basic",
        title: " / ML Controller / Charts",
    },
    ml_controller_summary: {
        module: "basic",
        title: " / ML Controller / Summary",
    },
    ml_predictor_dashboard: {
        module: "basic",
        title: " / ML Predictor / Dashboard",
    },
    ml_predictor_charts: { module: "basic", title: " / ML Predictor / Charts" },
    ml_predictor_summary: {
        module: "basic",
        title: " / ML Predictor / Summary",
    },
    "oee-console": { module: "basic", title: "OEE Console" },
    rules_controller_dashboard: {
        module: "basic",
        title: " / Rules Controller / Dashboard",
    },
    rules_controller_charts: {
        module: "basic",
        title: " / Rules Controller / Charts",
    },
    rules_controller_summary: {
        module: "basic",
        title: " / Rules Controller / Summary",
    },
    training_wheels_dashboard: {
        module: "basic",
        title: " / Training Wheels / Dashboard",
    },
    state_action_matrix: { module: "controls", title: "State Action Matrix" },
    training_wheels_charts: {
        module: "basic",
        title: " / Training Wheels / Charts",
    },
    training_wheels_summary: {
        module: "basic",
        title: " / Training Wheels / Summary",
    },
    matrix_controller_dashboard: {
        module: "basic",
        title: " / Matrix Controller / Dashboard",
    },
    matrix_controller_output_charts: {
        module: "basic",
        title: " / Matrix Controller / Output",
    },
    matrix_controller_equipment_charts: {
        module: "basic",
        title: " / Matrix Controller / Equipment",
    },
    run_summary_run_report: {
        module: "basic",
        title: " / Run Summary / Run Report",
    },
    run_summary_data_quality: {
        module: "basic",
        title: " / Run Summary / Data Quality",
    },
    run_events: {
        module: "basic",
        title: " / Events",
    },
    run_data_explorer: {
        module: "controls",
        title: " / Data Explorer",
    },
    // Add run details route
    runs: { module: "controls", title: "Run Details" },
    runId: { module: "controls", title: "Run Details" },
    // Add profile route
    profile: { module: "basic", title: "User Profile" },
};
